export interface SavingsBadgeIconProps {
  size?: { width: number; height: number };
}

export default function SavingsBadgeIcon({
  size = { width: 14, height: 14 },
}: SavingsBadgeIconProps) {
  return (
    <svg
      width={`${size.width}`}
      height={`${size.height}`}
      viewBox={`0 0 14 14`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="tags 1" clipPath="url(#clip0_3345_6395)">
        <path
          id="Vector"
          d="M12.9253 1.88672V5.27593C12.9253 5.70679 12.7543 6.12004 12.4497 6.4248L6.1875 12.6876C6.03514 12.8399 5.82851 12.9254 5.61306 12.9254C5.39762 12.9254 5.19099 12.8399 5.03863 12.6876L1.3125 8.96089C1.16018 8.80852 1.07461 8.60189 1.07461 8.38645C1.07461 8.171 1.16018 7.96438 1.3125 7.81201L7.57471 1.5498C7.87947 1.24523 8.29272 1.07417 8.72359 1.07422H12.1128C12.3283 1.07422 12.5349 1.15982 12.6873 1.31219C12.8397 1.46457 12.9253 1.67123 12.9253 1.88672Z"
          fill="url(#paint0_linear_3345_6395)"
          stroke="url(#paint1_linear_3345_6395)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M9.26884 5.42679C8.88422 5.42679 8.57241 5.11499 8.57241 4.73036C8.57241 4.34574 8.88422 4.03394 9.26884 4.03394C9.65347 4.03394 9.96527 4.34574 9.96527 4.73036C9.96527 5.11499 9.65347 5.42679 9.26884 5.42679Z"
          fill="white"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_3345_6395"
          x1="6.99995"
          y1="1.07422"
          x2="6.99995"
          y2="12.9254"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2A00A5" />
          <stop offset="1" stopColor="#60008D" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3345_6395"
          x1="6.99995"
          y1="1.07422"
          x2="6.99995"
          y2="12.9254"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2A00A5" />
          <stop offset="1" stopColor="#60008D" />
        </linearGradient>
        <clipPath id="clip0_3345_6395">
          <rect
            width="13"
            height="13"
            fill="white"
            transform="matrix(-1 0 0 1 13.5 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
